import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        const triggers = document.querySelectorAll( '[data-modal-trigger]' );
        triggers.forEach( ( trigger ) => {
            const id = trigger.getAttribute( 'data-modal-trigger' );
            
            trigger.addEventListener( 'click', function() {
                const target = document.querySelector( '[data-modal-target="' + id + '"]' );
                target.classList.toggle( 'opened' );
                document.body.classList.toggle( 'modal-opened' );

                if ( target.classList.contains( 'opened' ) ) {
                    disableBodyScroll( target.querySelector( '[data-modal-window]' ) );
                } else {
                    clearAllBodyScrollLocks();
                }
            } );
        } );
    }
}